"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const String_1 = require("helpers/String");
const uuid_1 = require("uuid");
const CLEAR_HTML_TAG_REGEX = /<(\/?)(p|a|strong|em|u|br)[^>]*>/g;
class QuizUtils {
    getQuestionMarker(index) {
        return (index + 1).toString();
    }
    getAnswerMarker(questionIndex, answerIndex) {
        const questionMarker = this.getQuestionMarker(questionIndex);
        const answerMarker = (0, String_1.convertColumnNumberToAlphabetLetter)(answerIndex + 1);
        return `${questionMarker}${answerMarker}`;
    }
    textIsEmpty(text) {
        return !text.replace(CLEAR_HTML_TAG_REGEX, '');
    }
    generateNewId() {
        return `new_${(0, uuid_1.v4)()}`;
    }
}
exports.default = new QuizUtils();
